/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { createContext } from 'react';

var defaultClassPrefix = "t";
var defaultContext = {
  classPrefix: defaultClassPrefix
};
var ConfigContext = /*#__PURE__*/createContext(defaultContext);

export { ConfigContext as default, defaultClassPrefix, defaultContext };
//# sourceMappingURL=ConfigContext.js.map
